<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('products')">Prodotti</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="product.deleted_at" class="mb-6" @restore="restore"> Questo prodotto è stato cancellato. </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.sku" :error="form.errors.sku" class="pr-6 pb-8 w-full lg:w-1/2" label="SKU" />
          <text-input v-model="form.ean_produttore" :error="form.errors.ean_produttore" class="pr-6 pb-8 w-full lg:w-1/2" label="EAN produttore" />
          <text-input v-model="form.cod_art_produttore" :error="form.errors.cod_art_produttore" class="pr-6 pb-8 w-full lg:w-1/2" label="Codice articolo produttore" />
          <text-input v-model="form.brand" :error="form.errors.brand" class="pr-6 pb-8 w-full lg:w-1/2" label="Brand" />
          <text-input v-model="form.categoria" :error="form.errors.categoria" class="pr-6 pb-8 w-full lg:w-1/2" label="Categoria" />
          <text-input v-model="form.stagione" :error="form.errors.stagione" class="pr-6 pb-8 w-full lg:w-1/2" label="Stagione" />
          <text-input v-model="form.genere" :error="form.errors.genere" class="pr-6 pb-8 w-full lg:w-1/2" label="Genere" />
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome" />
          <text-input v-model="form.taglia" :error="form.errors.taglia" class="pr-6 pb-8 w-full lg:w-1/2" label="Taglia" />
          <text-input v-model="form.colore" :error="form.errors.colore" class="pr-6 pb-8 w-full lg:w-1/2" label="Colore" />
          <!-- <text-input v-model="form.prezzo_acquisto" :error="form.errors.prezzo_acquisto" class="pr-6 pb-8 w-full lg:w-1/2" label="Prezzo di acquisto" /> -->
          <text-input v-model="form.prezzo_unitario" :error="form.errors.prezzo_unitario" class="pr-6 pb-8 w-full lg:w-1/2" label="Prezzo unitario" />
          <!-- <text-input v-model="form.quantita" :error="form.errors.quantita" class="pr-6 pb-8 w-full lg:w-1/2" label="Quantità" /> -->

          <!-- <select-input v-model="form.batch_id" :error="form.errors.batch_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Lotto">
            <option :value="null" />
            <option v-for="batch in batches" :key="batch.id" :value="batch.id">{{ batch.nome }}</option>
          </select-input> -->
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!product.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Elimina Prodotto</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Aggiorna Prodotto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `Modifica Prodotto`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    product: Object,
    batches: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sku: this.product.sku,
        ean_produttore: this.product.ean_produttore,
        cod_art_produttore: this.product.cod_art_produttore,
        brand: this.product.brand,
        categoria: this.product.categoria,
        stagione: this.product.stagione,
        genere: this.product.genere,
        name: this.product.name,
        taglia: this.product.taglia,
        colore: this.product.colore,
        // prezzo_acquisto: this.product.prezzo_acquisto,
        prezzo_unitario: this.product.prezzo_unitario,
        // quantita: this.product.quantita,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('products.update', this.product.id))
    },
    destroy() {
      if (confirm('Vuoi eliminare questo prodotto?')) {
        this.$inertia.delete(this.route('products.destroy', this.product.id))
      }
    },
    restore() {
      if (confirm('Vuoi ripristinare questo prodotto?')) {
        this.$inertia.put(this.route('products.restore', this.product.id))
      }
    },
  },
}
</script>
